import CIMSTable from 'components/CIMSTable'
import { useTypesTableContext } from '../../TypesTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

export const TypesTable: React.VFC = () => {
  const { records, fetching, refetch } = useTypesTableContext()

  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={useColumns()}
      actions={{
        header: {
          onReload: refetch,
          create: useCreate(),
        },
        row: {
          edit: useEdit(),
          remove: useRemove(),
          restore: useRestore(),
        },
      }}
      expand={useExpand()}
    />
  )
}
